import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Button } from 'atoms/buttons/Button';
import { HeadlineM } from 'atoms/typography';
import { Dialog } from 'components/dialog';
import { useScreenSize } from 'hooks/device/useScreenSize';
import { glossary } from 'lib/glossary';
import { TextDocument } from 'routing/TextDocument/lazy';

const Content = styled.div`
  padding: var(--triple-unit);
  margin: 0 calc(-1 * var(--unit));
`;

type Terms =
  | 'boostedCreditTerms'
  | 'referralTerms'
  | 'loanTerms'
  | 'duoMissionTerms'
  | 'creditTerms'
  | 'terms'
  | 'quickPlayTerms';

const messages = defineMessages<Terms>({
  terms: {
    id: 'ConversionCredit.TermsDialog.path',
    defaultMessage: 'DISCOUNT_CREDIT_TERMS.md',
  },
  referralTerms: {
    id: 'ConversionCredit.TermsDialog.referralTerms.path',
    defaultMessage: 'DISCOUNT_REFERRAL_CREDIT_TERMS.md',
  },
  loanTerms: {
    id: 'ConversionCredit.TermsDialog.loanTerms.path',
    defaultMessage: 'LOAN_OFFER_TERMS.md',
  },
  creditTerms: {
    id: 'CreditTerms.path',
    defaultMessage: 'CREDIT_TERMS.md',
  },
  boostedCreditTerms: {
    id: 'BoostedCreditTerms.path',
    defaultMessage: 'BOOSTED_CREDIT_TERMS.md',
  },
  duoMissionTerms: {
    id: 'ConversionCredit.TermsDialog.duoMissionTerms.path',
    defaultMessage: 'DUO_MISSION_TERMS.md',
  },
  quickPlayTerms: {
    id: 'QuickPlayRules.path',
    defaultMessage: 'QUICK_PLAY_RULES.md',
  },
});

type Props = {
  terms?: Terms;
  fileName?: string;
  onClose: () => void;
};
export const TermsDialog = ({ terms = 'terms', fileName, onClose }: Props) => {
  const { formatMessage } = useIntl();
  const { up: isLaptop } = useScreenSize('laptop');
  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open
      onClose={onClose}
      fullScreen={!isLaptop}
      title={
        <HeadlineM className="text-center" as="h3">
          <FormattedMessage
            id="TermsDialog.title"
            defaultMessage="Terms & conditions"
          />
        </HeadlineM>
      }
      footer={
        <Button fullWidth size="medium" color="secondary" onClick={onClose}>
          <FormattedMessage {...glossary.ok} />
        </Button>
      }
    >
      <Content dir="ltr">
        <TextDocument document={fileName || formatMessage(messages[terms])} />
      </Content>
    </Dialog>
  );
};
